export const getError = state => state.SearchingR.error;
export const getSearchingData = state => state.SearchingR.searching;
export const getSearchingDataInput = state => state.SearchingR.searchingInput;
export const loading = state => state.SearchingR.loading;
export const loadMoreData = state => state.SearchingR.loadMoreData;
